<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-right: 15px; padding-left: 15px;"
    v-if="list != null"
>
    <h3>General Settings</h3>

    <v-row>
        <v-col>
            <v-text-field
                label="Internal Label"
                v-model="list.list_internal_label"
                v-on:input="saveMetaData"
                autocomplete="off"
            />
        </v-col>

        <v-col>
            <v-text-field
                label="External Label"
                v-model="list.list_external_label"
                v-on:input="saveMetaData"
                autocomplete="off"
            />
        </v-col>
    </v-row>

    <h3>Drip Messages</h3>

    <m-auto-message-template-search-table
        v-if="list != null"
        :organization_id = "list.organization_id"
        :show_column_type="false"
        show_column_patterns
        show_column_delay
        :list_id="list.list_id"
        :show_list_label="false"
    />

    <br/>
    <h3>Members</h3>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="updateMembers"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickAddContacts"
                >
                    <v-list-item-title>Add Contact(s)...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickAddFromExcel"
                >
                    <v-list-item-title>Add From Excel...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickExport"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickRemoveAll"
                >
                    <v-list-item-title>Remove All List Members...</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint, 'endpoint')}}
        </template>
    
        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.time_member_since, 'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.time_member_since, 'time')}}
        </template>
        
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEditContact(item)"
                >
                    <v-list-item-title>Edit Contact...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickRemove(item)"
                >
                    <v-list-item-title>Remove...</v-list-item-title>
                </v-list-item>


            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

     <m-autocomplete-phone-number
            ref="add-phone-numbers"
            dialog_only
            :default_multiselect="true"
            action_button_text="Add Contacts"
            v-on:start-group-text="onAddMultipleContacts"
        />
    
    <m-dialog-add-multiple-list-members-text
            ref="dialog-add-multiple-text"
            v-on:add="onAddMultipleMembersText"
        />

    <m-edit-contact-dialog
        ref="edit-contact-dialog"
        v-on:ok="onUpsertContact"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    
    data() {
        return {
            list: null,
            full_text: null,
            results: [],
            headers: [
                { text: 'Phone Number', value: 'endpoint'},
                { text: 'Name', value: 'endpoint_label'},
                { text: 'Member Since (Date)', value: 'date'},
                { text: 'Member Since (Time)', value: 'time'},
                { text: 'State', value: 'opt_out_state'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdateMembers();
        this.$rc.showSpinner();
        
        this.$rc.rest(
            'GET: /api/v1/lists/:list_id',
        
            {
                'list_id' : this.$route.params.list_id,
            },
        
            (data) => {
                this.$rc.hideSpinner();

                this.list = data;
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to download list');
            },
        );
    },

    methods: {

        saveMetaData: _.debounce(function(){
            this.doSaveMetaData();
        }, 751),
        
        doSaveMetaData()
        {
            this.$rc.rest(
                'PUT: /api/v1/lists',
            
                this.list,
            
                (data) => {
                    
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save list');
                },
            );
        },

        updateMembers: _.debounce(function(){
            this.doUpdateMembers();
        }, 751),
        
        doUpdateMembers()
        { 
            this.$rc.rest(
                'LIST: /api/v1/lists/members',
            
                {
                    'list_id' : this.$route.params.list_id,
                    'full_text': this.full_text
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get list members');
                },
            );
        },
        

        onClickAddContacts()
        {
            this.$refs['add-phone-numbers'].showDialog();
        },

        onAddMultipleContacts(data)
        {
            let text = "";

            for ( let i = 0; i < data.length; i++ )
            {
                text += data[i].value;
                text += '\n';
            }

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'ADD-MULTIPLE: /api/v1/lists/members',
            
                {
                    'list_id' : this.$route.params.list_id,
                    'text' : text,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdateMembers();
                    this.$rc.snackbar('Contacts added');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add contacts');
                },
            );
        },
        
        onClickAddFromExcel()
        {
            this.$refs['dialog-add-multiple-text'].showDialog(this.list.organization_id);
        },

        onAddMultipleMembersText(text)
        {
            this.$rc.rest(
                'ADD-MULTIPLE: /api/v1/lists/members',
            
                {
                    'list_id' : this.$route.params.list_id,
                    'text' : text,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdateMembers();
                    this.$rc.snackbar('Added numbers to list');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add numbers');
                },
            );
        },
        
        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/lists/:list_id',
                    {
                        'list_id' : this.$route.params.list_id,
                    }
                );
        },

        onClickRemoveAll()
        {
            this.$rc.confirm(
                'Confirm Remove All List Members',
                'Are you sure you want to remove **ALL** list members?  This can not be undone?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Confirm', 'value': 'confirm'},
                ],
            
                (response) => {
                    if (response != 'confirm') return;
                    
                    this.$rc.showSpinner();
                    
                    this.$rc.rest(
                        'REMOVE-ALL: /api/v1/lists/members',
                    
                        {
                            'list_id' : this.$route.params.list_id,
                        },
                    
                        (data) => {
                            this.$rc.hideSpinner();
                            this.doUpdateMembers();
                            this.$rc.snackbar('All members have been removed from the list', 1000);
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to remove all members from the list');
                        },
                    );
                }
            );
        },

        onClickEditContact(item)
        {
            this.$rc.getContactByEndpoint(item.endpoint, this.showEditContactDialog);
        },

        showEditContactDialog(contact)
        {
            this.$refs['edit-contact-dialog'].showDialog(contact);
        },

        onUpsertContact(new_contact)
        {
            this.$rc.upsertContact(
                new_contact, 
                () => { this.doUpdateMembers(); }
            );

        },

        onClickRemove(item)
        {
            this.$rc.confirm(
                'Confirmation Remove',
                'Remove list member: '+item.endpoint_label,
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Remove', 'value': 'confirm'},
                ],
            
                (response) => {
                    if (response != 'confirm') return;
                    
                    this.$rc.showSpinner();
                    
                    this.$rc.rest(
                        'REMOVE: /api/v1/lists/members',
                    
                        {
                            'list_id' : this.$route.params.list_id,
                            'endpoint' : item.endpoint,
                        },
                    
                        (data) => {
                            this.$rc.hideSpinner();
                            this.doUpdateMembers();
                            this.$rc.snackbar(item.endpoint_label+' removed from list', 1000);
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to complete API call');
                        },
                    );
                }
            );
        }
        
    },

    computed: {
        title() {
            if ( this.list == null )
                return 'Edit List';

            return this.list.organization_label+': '+this.list.list_internal_label;
        }
    },

}
</script>

<style lang="scss" scoped>
</style>